/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { useSelector } from "react-redux";

function RightMenu(props) {
  const user = useSelector(state => state.user);

  const logoutHandler = () => {
    axios.get(`/auth/al/logout`).then(response => {
      if (response.status === 200) {
        props.history.push("/login");
      } else {
        alert('Log Out Failed');
      }
    });
  };

  const handleItemClick = () => {
    if (props.onItemClick) {
      props.onItemClick();
    }
  };

  if (user.userData && !user.userData.isAuth) {
    return (
      <ul className="menu-list right-menu">
        <li className="menu-item">
          <a href="/login" onClick={handleItemClick}>Sign In</a>
        </li>
        <li className="menu-item">
          <a href="/register" onClick={handleItemClick}>Sign Up</a>
        </li>
      </ul>
    );
  } else {
    return (
      <ul className="menu-list right-menu">
        <li className="menu-item">
          <button 
            className="menu-link logout-btn danger-btn" 
            onClick={() => { logoutHandler(); handleItemClick(); }}
          >
            Logout
          </button>
        </li>
      </ul>
    );
  }
}

export default withRouter(RightMenu);

